import axios from './axios';

/**
 * Get all payments for a contract
 */
export const getContractPayments = async (contractId) => {
  const response = await axios.get(`/contracts/${contractId}/payments`);
  return response.data;
};

/**
 * Generate payments for a signed contract
 */
export const generatePayments = async (contractId) => {
  const response = await axios.post(`/contracts/${contractId}/payments/generate`);
  return response.data;
};

/**
 * Get payment summary for a contract
 */
export const getPaymentSummary = async (contractId) => {
  const response = await axios.get(`/contracts/${contractId}/payments/summary`);
  return response.data;
};

/**
 * Update payment status
 */
export const updatePaymentStatus = async (paymentId, status, paidDate = null, notes = null) => {
  const response = await axios.put(`/payments/${paymentId}/status`, {
    status,
    paid_date: paidDate,
    notes
  });
  return response.data;
};

/**
 * Update a payment
 */
export const updatePayment = async (paymentId, updates) => {
  const response = await axios.put(`/payments/${paymentId}`, updates);
  return response.data;
};

/**
 * Delete a payment
 */
export const deletePayment = async (paymentId) => {
  const response = await axios.delete(`/payments/${paymentId}`);
  return response.data;
};

/**
 * Create manual payment schedule for a contract
 */
export const createManualPayments = async (contractId, payments) => {
  const response = await axios.post(`/payments/contract/${contractId}/manual`, {
    payments
  });
  return response.data;
};

/**
 * Get all unpaid payments with optional filters
 */
export const getUnpaidPayments = async (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.date_from) params.append('date_from', filters.date_from);
  if (filters.date_to) params.append('date_to', filters.date_to);
  if (filters.trainer_id) params.append('trainer_id', filters.trainer_id);
  if (filters.contract_id) params.append('contract_id', filters.contract_id);
  if (filters.amount_min !== undefined) params.append('amount_min', filters.amount_min);
  if (filters.amount_max !== undefined) params.append('amount_max', filters.amount_max);
  if (filters.contract_status) params.append('contract_status', filters.contract_status);
  if (filters.payment_frequency) params.append('payment_frequency', filters.payment_frequency);
  if (filters.search) params.append('search', filters.search);
  
  const response = await axios.get(`/payments/unpaid?${params.toString()}`);
  return response.data;
};

/**
 * Export payments as PAIN.001 XML file
 */
export const exportPain001 = async (exportData) => {
  const response = await axios.post('/payments/export/pain001', exportData, {
    responseType: 'blob' // Important for file download
  });
  return response;
};